import {Box, Button, Field, Heading, Input, Stack, Table, Text, VStack} from "@chakra-ui/react";
import React, {useCallback, useEffect, useState} from "react";
import {Company, CompanyExecutor, dataApi} from "../../api/data-api";
import {useToast} from "@chakra-ui/toast";
import {useRecoilState} from "recoil";
import {executorData} from "../../components/hooks/recoilData";
import ExecutorContract from "../Executor/executorContract";
import {errorNotify} from "../../components/hooks/CommonUtils";


export const Employer = () => {
    const [items, setItems] = useState<Company[]>([]);
    const toast = useToast();
    const [executor] = useRecoilState(executorData);
    const [companyId, setCompanyId] = useState<number>(0);
    const [show, setShow] = useState<boolean>(false);
    const [currentExecutor, setCurrentExecutor] = useState<CompanyExecutor>();
    const [companyExecutors, setCompanyExecutors] = useState<CompanyExecutor[]>([]);

    useEffect(() => {
        if (executor) {
            dataApi.companyForExecutorList(executor.ID)
                .then((o) => {
                    setItems(o);
                })
                .catch((err) => errorNotify(err, toast));
            dataApi.companyExecutorListByExecutor(executor.ID)
                .then((o) => {
                    setCompanyExecutors(o);
                })
                .catch((err) => errorNotify(err, toast));
        }
    }, [executor, toast]);

    const showDlg = useCallback((item: Company) => {
        if (!executor)
            return;
        const find = companyExecutors.find(e => e.EXECUTOR_ID === executor.ID);
        if (find)
            setCurrentExecutor(find);
        setShow(!!item)
    }, [executor, companyExecutors]);

    const join = useCallback(() => {
        if (!companyId)
            return;
        dataApi.companyGet(companyId)
            .then((o) => {
                if (!o.CONFIRMED)
                    return;
                dataApi.executorCompanyJoin(o.ID)
                    .then((o2) => {
                        if (o2) {
                            toast({title: "Join", status: "success"});
                            setItems(prev => {
                                return [o, ...prev];
                            });
                            if (executor) {
                                dataApi.companyExecutorListByExecutor(executor.ID)
                                    .then((o) => {
                                        setCompanyExecutors(o);
                                    })
                                    .catch((err) => errorNotify(err, toast));
                            }
                        } else {
                            toast({title: "Join failed", status: "error"});
                        }
                    })
                    .catch((err) => errorNotify(err, toast));
            })
            .catch((err) => errorNotify(err, toast));
    }, [companyId, toast, executor]);

    const accept = useCallback(() => {
        if (!companyId)
            return;
        dataApi.executorCompanyAccept(companyId)
            .then((o) => {
                toast({title: "Accepted", status: "success"});
                setCompanyExecutors(prev => {
                    const lst = [...prev];
                    const find = lst.find(e => e.COMPANY_ID === companyId);
                    if (find)
                        find.ACCEPTED = new Date().getTime();
                    return lst;
                });
            })
            .catch((err) => errorNotify(err, toast));
    }, [companyId, toast]);

    const isNeedAccept = useCallback((item: Company) => {
        const find = companyExecutors.find(e => e.COMPANY_ID === item.ID);
        return find && !find.ACCEPTED;
    }, [companyExecutors]);

    return (
        <VStack>
            <Box borderWidth={1} borderColor="gray">
                <Text>Присоединиться к компании</Text>
                <Stack>
                    <Field.Root orientation="horizontal" required>
                        <Field.Label>Ид компании <Field.RequiredIndicator/></Field.Label>
                        <Input type="number" placeholder="Ид компании"
                               value={companyId}
                               onChange={(it) => setCompanyId(parseInt(it.target.value))}/>
                    </Field.Root>
                    <Button
                        borderRadius={0}
                        variant="solid"
                        colorScheme="teal"
                        width="full"
                        onClick={join}
                    >
                        Присоединиться
                    </Button>
                </Stack>
            </Box>

            <ExecutorContract executor={currentExecutor} isCompany={false} show={show} setShow={setShow}/>
            <Stack width="full" gap="5">
                <Heading size="xl">Работодатели</Heading>
                <Table.Root size="sm" variant="outline" striped>
                    <Table.Header>
                        <Table.Row>
                            <Table.ColumnHeader>Пользователь</Table.ColumnHeader>
                            <Table.ColumnHeader>Имя</Table.ColumnHeader>
                            <Table.ColumnHeader>Адрес</Table.ColumnHeader>
                            <Table.ColumnHeader>ИНН</Table.ColumnHeader>
                            <Table.ColumnHeader>Email</Table.ColumnHeader>
                            <Table.ColumnHeader>Телефон</Table.ColumnHeader>
                            <Table.ColumnHeader>Действия</Table.ColumnHeader>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {items.map((item) => (
                            <Table.Row key={item.ID}>
                                <Table.Cell>{item.USER_ID}</Table.Cell>
                                <Table.Cell>{item.NAME}</Table.Cell>
                                <Table.Cell>{item.ADDRESS}</Table.Cell>
                                <Table.Cell>{item.CODE_INN}</Table.Cell>
                                <Table.Cell>{item.EMAIL}</Table.Cell>
                                <Table.Cell>{item.TEL}</Table.Cell>
                                <Table.Cell>
                                    <Button onClick={e => showDlg(item)}>Контракты</Button>
                                    <Button
                                        display={isNeedAccept(item) ? "block" : "none"}
                                        onClick={accept}>Принять</Button>
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table.Root>

            </Stack>
        </VStack>
    );
};